import React, { useEffect, useMemo } from "react";
import styles from "./style.module.scss";
import TextInput from "../../../../../../../components/form/text-input";
import NumberInput from "../../../../../../../components/form/number-input";
import TextArea from "../../../../../../../components/form/text-area";
import Button from "../../../../../../../components/new-button";
import PlusIcon from "../../../../../../../assets/svg/icons/common/Plus";
import { FieldArray, useFormikContext } from "formik";

const BUSINESS_ACTIVITY_OPTIONS = [

  {
    label: "Travel Agent",
    value: "travel_agent",
  },
  {
    label: "Tour Operator",
    value: "tour_operator",
  },
  {
    label: "Event Ticket Sellers (Non-Sporting)",
    value: "event_ticket_sellers_non_sporting",
  },
  {
    label: "Stand Alone Travel Ticket Sellers & Tour Operators",
    value: "stand_alone_travel_ticket_sellers_tour_operators",
  },
  {
    label: "Event Organisers (Non-Sporting) ",
    value: "event_organisers_non_sporting",
  },
  {
    label: "Event Organisers (Sporting)",
    value: "event_organisers_sporting",
  },
  {
    label: "Third Party Event/Ticket Sellers/Touting",
    value: "third_party_event_ticket_sellers_touting",
  },
  {
    label: "Secondary Ticket Market (“C2C) / “Ticket Exchanges ",
    value: "secondary_ticket_market_c2c_ticket_exchanges",
  },
  {
    label: "Other",
    value: "other",
  },
];

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

const SEASONALITY_OPTIONS = [
  { key: "pct_annual_sales", label: "% of total annual sales processed in this month" },
  { key: "max_monthly_card_sales", label: "Estimated maximum monthly card sales (USD)" },
  { key: "min_monthly_card_sales", label: "Estimated minimum monthly card sales (USD)" },
  { key: "monthly_total_sales", label: "Estimated monthly total sales (card and non-card) for the company in this month (USD)" },
];

const DELIVERY_PERIODS = [
  { key: "1_7_days", label: "1-7 days" },
  { key: "8_14_days", label: "8-14 days" },
  { key: "15_30_days", label: "15-30 days" },
  { key: "31_60_days", label: "31-60 days" },
  { key: "61_90_days", label: "61-90 days" },
  { key: "91_120_days", label: "91-120 days" },
  { key: "121_150_days", label: "121-150 days" },
  { key: "151_180_days", label: "151-180 days" },
  { key: "over_180_days", label: "Over 180 days" },
];

const RemoveButton = ({ onClick, color = "#3A383F" }) => (
  <button type="button" className={styles.removeButton} onClick={onClick}>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M13.5 3H11V2.5C11 2.10218 10.842 1.72064 10.5607 1.43934C10.2794 1.15804 9.89782 1 9.5 1H6.5C6.10218 1 5.72064 1.15804 5.43934 1.43934C5.15804 1.72064 5 2.10218 5 2.5V3H2.5C2.36739 3 2.24021 3.05268 2.14645 3.14645C2.05268 3.24021 2 3.36739 2 3.5C2 3.63261 2.05268 3.75979 2.14645 3.85355C2.24021 3.94732 2.36739 4 2.5 4H3V13C3 13.2652 3.10536 13.5196 3.29289 13.7071C3.48043 13.8946 3.73478 14 4 14H12C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V4H13.5C13.6326 4 13.7598 3.94732 13.8536 3.85355C13.9473 3.75979 14 3.63261 14 3.5C14 3.36739 13.9473 3.24021 13.8536 3.14645C13.7598 3.05268 13.6326 3 13.5 3ZM6 2.5C6 2.36739 6.05268 2.24021 6.14645 2.14645C6.24021 2.05268 6.36739 2 6.5 2H9.5C9.63261 2 9.75979 2.05268 9.85355 2.14645C9.94732 2.24021 10 2.36739 10 2.5V3H6V2.5ZM12 13H4V4H12V13ZM7 6.5V10.5C7 10.6326 6.94732 10.7598 6.85355 10.8536C6.75979 10.9473 6.63261 11 6.5 11C6.36739 11 6.24021 10.9473 6.14645 10.8536C6.05268 10.7598 6 10.6326 6 10.5V6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24021 6.05268 6.36739 6 6.5 6C6.63261 6 6.75979 6.05268 6.85355 6.14645C6.94732 6.24021 7 6.36739 7 6.5ZM10 6.5V10.5C10 10.6326 9.94732 10.7598 9.85355 10.8536C9.75979 10.9473 9.63261 11 9.5 11C9.36739 11 9.24021 10.9473 9.14645 10.8536C9.05268 10.7598 9 10.6326 9 10.5V6.5C9 6.36739 9.05268 6.24021 9.14645 6.14645C9.24021 6.05268 9.36739 6 9.5 6C9.63261 6 9.75979 6.05268 9.85355 6.14645C9.94732 6.24021 10 6.36739 10 6.5Z"
        fill={color}
      />
    </svg>
  </button>
);

const SectionDivider = ({ label }) => (
  <div className={styles.sectionDivider}>
    <span className={styles.sectionLabel}>{label}</span>
    <div className={styles.dividerLine} />
  </div>
);

function getTravelGrossAnnualSubtotal(formValues) {
  return (
    (parseFloat(formValues.travel_sales_third_party_packages) || 0) +
    (parseFloat(formValues.travel_agency_accommodation_only) || 0) +
    (parseFloat(formValues.travel_agency_non_flight_transport) || 0) +
    (parseFloat(formValues.travel_flight_own_merchant) || 0) +
    (parseFloat(formValues.travel_flight_airline_merchant) || 0) +
    (parseFloat(formValues.travel_other_sales_agent) || 0)
  );
}

function TravelAddendum() {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
  } = useFormikContext();

  const travelGrossAnnualSubtotal = useMemo(
    () => getTravelGrossAnnualSubtotal(values),
    [
      values.travel_sales_third_party_packages,
      values.travel_agency_accommodation_only,
      values.travel_agency_non_flight_transport,
      values.travel_flight_own_merchant,
      values.travel_flight_airline_merchant,
      values.travel_other_sales_agent,
    ],
  );

  useEffect(() => {
    const total = 12 * travelGrossAnnualSubtotal;
    if (!Number.isFinite(total)) {
      return;
    }
    setFieldValue("travel_total_gross_turnover", String(total));
  }, [travelGrossAnnualSubtotal, setFieldValue]);

  const handleCheckboxChange = (option) => {
    const current = values.travel_business_activities || [];
    const updated = current.includes(option)
      ? current.filter((item) => item !== option)
      : [...current, option];
    console.log('updated business activities', updated);
    setFieldValue("travel_business_activities", updated);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h4 className={styles.sectionTitle}>Kurv - Travel Addendum</h4>
      </div>

      <div className={styles.formContent}>
        {/* Section 1: Business Activities */}
        <SectionDivider label="Business Activities" />
        <p className={styles.subtitle}>
          Which of the following best describes your business' activities (tick more than one, if applicable):
        </p>

        <div className={styles.checkboxGroup}>
          {BUSINESS_ACTIVITY_OPTIONS.map((option) => (
            <div
              key={option.value}
              className={`${styles.checkboxItem} ${values.travel_business_activities?.includes(option.value) ? styles.checked : ""}`}
              onClick={() => handleCheckboxChange(option.value)}
            >
              <input
                type="checkbox"
                checked={values.travel_business_activities?.includes(option.value)}
                onChange={() => handleCheckboxChange(option.value)}
              />
              <label>{option.label}</label>
            </div>
          ))}
        </div>
        {touched.travel_business_activities && errors.travel_business_activities && (
          <div className={styles.error}>{errors.travel_business_activities}</div>
        )}

        {values.travel_business_activities?.includes("other") && values.travel_business_activities?.length > 0 && (
          <div className={styles.formGroup}>
            <TextInput
              label="Other - please provide further details"
              placeholder="Describe your business activities"
              type="text"
              id="travel_other_business_activity"
              name="travel_other_business_activity"
              value={values.travel_other_business_activity}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched.travel_other_business_activity}
              errored={errors.travel_other_business_activity}
              error={errors.travel_other_business_activity}
            />
          </div>
        )}

        {/* Section 2: Gross Annual Turnover */}
        <SectionDivider label="Gross Annual Turnover as a Travel Agent" />

        <div className={styles.formRow}>
          <NumberInput
            label="Sales of third party packages (%)"
            placeholder="0"
            type="text"
            id="travel_sales_third_party_packages"
            name="travel_sales_third_party_packages"
            value={values.travel_sales_third_party_packages}
            onChange={(value) => setFieldValue("travel_sales_third_party_packages", value)}
            onBlur={handleBlur}
            touched={touched.travel_sales_third_party_packages}
            errored={errors.travel_sales_third_party_packages}
            error={errors.travel_sales_third_party_packages}
          />
          <NumberInput
            label="Agency sale of accommodation only (%)"
            placeholder="0"
            type="text"
            id="travel_agency_accommodation_only"
            name="travel_agency_accommodation_only"
            value={values.travel_agency_accommodation_only}
            onChange={(value) => setFieldValue("travel_agency_accommodation_only", value)}
            onBlur={handleBlur}
            touched={touched.travel_agency_accommodation_only}
            errored={errors.travel_agency_accommodation_only}
            error={errors.travel_agency_accommodation_only}
          />
        </div>

        <div className={styles.formRow}>
          <NumberInput
            label="Agency sale of non-flight transport only (%)"
            placeholder="0"
            type="text"
            id="travel_agency_non_flight_transport"
            name="travel_agency_non_flight_transport"
            value={values.travel_agency_non_flight_transport}
            onChange={(value) => setFieldValue("travel_agency_non_flight_transport", value)}
            onBlur={handleBlur}
            touched={touched.travel_agency_non_flight_transport}
            errored={errors.travel_agency_non_flight_transport}
            error={errors.travel_agency_non_flight_transport}
          />
          <NumberInput
            label="Flight only - through own merchant facility (%)"
            placeholder="0"
            type="text"
            id="travel_flight_own_merchant"
            name="travel_flight_own_merchant"
            value={values.travel_flight_own_merchant}
            onChange={(value) => setFieldValue("travel_flight_own_merchant", value)}
            onBlur={handleBlur}
            touched={touched.travel_flight_own_merchant}
            errored={errors.travel_flight_own_merchant}
            error={errors.travel_flight_own_merchant}
          />
        </div>

        <div className={styles.formRow}>
          <NumberInput
            label="Flight only - through airline merchant facility (%)"
            placeholder="0"
            type="text"
            id="travel_flight_airline_merchant"
            name="travel_flight_airline_merchant"
            value={values.travel_flight_airline_merchant}
            onChange={(value) => setFieldValue("travel_flight_airline_merchant", value)}
            onBlur={handleBlur}
            touched={touched.travel_flight_airline_merchant}
            errored={errors.travel_flight_airline_merchant}
            error={errors.travel_flight_airline_merchant}
          />
          <NumberInput
            label="Other sales as agent (%)"
            placeholder="0"
            type="text"
            id="travel_other_sales_agent"
            name="travel_other_sales_agent"
            value={values.travel_other_sales_agent}
            onChange={(value) => setFieldValue("travel_other_sales_agent", value)}
            onBlur={handleBlur}
            touched={touched.travel_other_sales_agent}
            errored={errors.travel_other_sales_agent}
            error={errors.travel_other_sales_agent}
          />
        </div>

        {values.travel_other_sales_agent && values.travel_other_sales_agent !== "0" && (
          <div className={styles.formGroup}>
            <TextInput
              label="Describe 'Other sales' as appropriate"
              placeholder="Describe other sales"
              type="text"
              id="travel_other_sales_description"
              name="travel_other_sales_description"
              value={values.travel_other_sales_description}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched.travel_other_sales_description}
              errored={errors.travel_other_sales_description}
              error={errors.travel_other_sales_description}
            />
          </div>
        )}

        <div className={styles.formRow}>
          <NumberInput
            label="SUBTOTAL"
            placeholder="SUBTOTAL"
            type="text"
            id="travel_subtotal"
            name="travel_subtotal"
            value={travelGrossAnnualSubtotal}
            // disabled={true}
            readOnly={true}
          />
        </div>

        <div className={styles.formRow}>
          <NumberInput
            label="TOTAL GROSS TURNOVER"
            placeholder="TOTAL GROSS TURNOVER"
            type="text"
            id="travel_total_gross_turnover"
            name="travel_total_gross_turnover"
            value={values.travel_total_gross_turnover}
            onChange={(value) => setFieldValue("travel_total_gross_turnover", value)}
            onBlur={handleBlur}
            touched={touched.travel_total_gross_turnover}
            errored={errors.travel_total_gross_turnover}
            error={errors.travel_total_gross_turnover}
          />
        </div>

        {/* Section 3: Airlines / Travel Suppliers */}
        <SectionDivider label="Airlines / Travel Suppliers" />
        <p className={styles.subtitle}>{`Please list Airlines, Cruise lines and other “travel by land/air/sea” suppliers supported (>10% of sales)`}</p>

        <FieldArray name="travel_airline_suppliers">
          {({ push, remove }) => (
            <div className={styles.supplierList}>
              {values.travel_airline_suppliers?.map((supplier, index) => (
                <div className={styles.supplierRow} key={index}>
                  <div className={styles.supplierRowInputs}>
                    <TextInput
                      label="Supplier Name"
                      placeholder="Supplier Name"
                      type="text"
                      id={`travel_airline_suppliers.${index}.name`}
                      name={`travel_airline_suppliers.${index}.name`}
                      value={supplier.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors?.travel_airline_suppliers?.[index]?.name}
                      touched={touched?.travel_airline_suppliers?.[index]?.name}
                      errored={errors?.travel_airline_suppliers?.[index]?.name}
                    />
                    <TextInput
                      label="Country of base"
                      placeholder="Country"
                      type="text"
                      id={`travel_airline_suppliers.${index}.country`}
                      name={`travel_airline_suppliers.${index}.country`}
                      value={supplier.country}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors?.travel_airline_suppliers?.[index]?.country}
                      touched={touched?.travel_airline_suppliers?.[index]?.country}
                      errored={errors?.travel_airline_suppliers?.[index]?.country}
                    />
                    <TextInput
                      label="Payment terms"
                      placeholder="Payment terms"
                      type="text"
                      id={`travel_airline_suppliers.${index}.payment_terms`}
                      name={`travel_airline_suppliers.${index}.payment_terms`}
                      value={supplier.payment_terms}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors?.travel_airline_suppliers?.[index]?.payment_terms}
                      touched={touched?.travel_airline_suppliers?.[index]?.payment_terms}
                      errored={errors?.travel_airline_suppliers?.[index]?.payment_terms}
                    />
                    <NumberInput
                      label="% share of all flight spend"
                      placeholder="0"
                      type="number"
                      id={`travel_airline_suppliers.${index}.flight_spend_share`}
                      name={`travel_airline_suppliers.${index}.flight_spend_share`}
                      value={supplier.flight_spend_share}
                      onChange={(value) => setFieldValue(`travel_airline_suppliers.${index}.flight_spend_share`, value)}
                      onBlur={handleBlur}
                      error={errors?.travel_airline_suppliers?.[index]?.flight_spend_share}
                      touched={touched?.travel_airline_suppliers?.[index]?.flight_spend_share}
                      errored={errors?.travel_airline_suppliers?.[index]?.flight_spend_share}
                    />

                    <NumberInput
                      label="Average % of package cost"
                      placeholder="0"
                      type="number"
                      id={`travel_airline_suppliers.${index}.average_package_cost`}
                      name={`travel_airline_suppliers.${index}.average_package_cost`}
                      value={supplier.average_package_cost}
                      onChange={(value) => setFieldValue(`travel_airline_suppliers.${index}.average_package_cost`, value)}
                      onBlur={handleBlur}
                      error={errors?.travel_airline_suppliers?.[index]?.average_package_cost}
                      touched={touched?.travel_airline_suppliers?.[index]?.average_package_cost}
                      errored={errors?.travel_airline_suppliers?.[index]?.average_package_cost}
                    />
                  </div>
                  {index > 0 ? (
                    <div className={styles.supplierRowButtons}>
                      <RemoveButton onClick={() => remove(index)} />
                    </div>
                  ) : (
                    <div className={styles.supplierRowButtons}>
                      <RemoveButton color="#FFF" />
                    </div>
                  )}
                </div>
              ))}
              {values.travel_airline_suppliers?.length < 6 && (
                <Button
                  onClick={() => push({ name: "", country: "", payment_terms: "", flight_spend_share: "", average_package_cost: "" })}
                  variant="ghost"
                  icon={<PlusIcon color="#4C70EF" />}
                  type="button"
                >
                  Add Supplier
                </Button>
              )}
              {typeof errors?.travel_airline_suppliers === "string" && (
                <div className={styles.error}>{errors.travel_airline_suppliers}</div>
              )}
            </div>
          )}
        </FieldArray>

        <div className={styles.formGroup}>
          <NumberInput
            label="Total % of all spend on Travel by land/air/sea"
            placeholder="0"
            type="number"
            id="travel_total_spend_travel"
            name="travel_total_spend_travel"
            value={values.travel_total_spend_travel}
            onChange={(value) => setFieldValue("travel_total_spend_travel", value)}
            onBlur={handleBlur}
            touched={touched.travel_total_spend_travel}
            errored={errors.travel_total_spend_travel}
            error={errors.travel_total_spend_travel}
          />
        </div>

        {/* Section 4: Hotels/Accommodation Suppliers */}
        <SectionDivider label="Hotels / Accommodation Suppliers" />
        <p className={styles.subtitle}>
          Please list Hotels/Accommodation supported (&gt;10% of sales)
        </p>

        <FieldArray name="travel_hotel_suppliers">
          {({ push, remove }) => (
            <div className={styles.supplierList}>
              {values.travel_hotel_suppliers?.map((supplier, index) => (
                <div className={styles.supplierRow} key={index}>
                  <div className={styles.supplierRowInputs}>
                    <TextInput
                      label="Supplier Name"
                      placeholder="Supplier Name"
                      type="text"
                      id={`travel_hotel_suppliers.${index}.name`}
                      name={`travel_hotel_suppliers.${index}.name`}
                      value={supplier.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors?.travel_hotel_suppliers?.[index]?.name}
                      touched={touched?.travel_hotel_suppliers?.[index]?.name}
                      errored={errors?.travel_hotel_suppliers?.[index]?.name}
                    />
                    <TextInput
                      label="Country of base"
                      placeholder="Country"
                      type="text"
                      id={`travel_hotel_suppliers.${index}.country`}
                      name={`travel_hotel_suppliers.${index}.country`}
                      value={supplier.country}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors?.travel_hotel_suppliers?.[index]?.country}
                      touched={touched?.travel_hotel_suppliers?.[index]?.country}
                      errored={errors?.travel_hotel_suppliers?.[index]?.country}
                    />
                    <TextInput
                      label="Payment terms"
                      placeholder="Payment terms"
                      type="text"
                      id={`travel_hotel_suppliers.${index}.payment_terms`}
                      name={`travel_hotel_suppliers.${index}.payment_terms`}
                      value={supplier.payment_terms}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors?.travel_hotel_suppliers?.[index]?.payment_terms}
                      touched={touched?.travel_hotel_suppliers?.[index]?.payment_terms}
                      errored={errors?.travel_hotel_suppliers?.[index]?.payment_terms}
                    />
                    <NumberInput
                      label="% share of all hotel spend"
                      placeholder="0"
                      type="number"
                      id={`travel_hotel_suppliers.${index}.hotel_spend_share`}
                      name={`travel_hotel_suppliers.${index}.hotel_spend_share`}
                      value={supplier.hotel_spend_share}
                      onChange={(value) => setFieldValue(`travel_hotel_suppliers.${index}.hotel_spend_share`, value)}
                      onBlur={handleBlur}
                      error={errors?.travel_hotel_suppliers?.[index]?.hotel_spend_share}
                      touched={touched?.travel_hotel_suppliers?.[index]?.hotel_spend_share}
                      errored={errors?.travel_hotel_suppliers?.[index]?.hotel_spend_share}
                    />
                    <NumberInput
                      label="Average % of package cost"
                      placeholder="0"
                      type="number"
                      id={`travel_hotel_suppliers.${index}.average_package_cost`}
                      name={`travel_hotel_suppliers.${index}.average_package_cost`}
                      value={supplier.average_package_cost}
                      onChange={(value) => setFieldValue(`travel_hotel_suppliers.${index}.average_package_cost`, value)}
                      onBlur={handleBlur}
                      error={errors?.travel_hotel_suppliers?.[index]?.average_package_cost}
                      touched={touched?.travel_hotel_suppliers?.[index]?.average_package_cost}
                      errored={errors?.travel_hotel_suppliers?.[index]?.average_package_cost}
                    />
                  </div>
                  {index > 0 ? (
                    <div className={styles.supplierRowButtons}>
                      <RemoveButton onClick={() => remove(index)} />
                    </div>
                  ) : (
                    <div className={styles.supplierRowButtons}>
                      <RemoveButton color="#FFF" />
                    </div>
                  )}
                </div>
              ))}
              {values.travel_hotel_suppliers?.length < 6 && (
                <Button
                  onClick={() => push({ name: "", country: "", payment_terms: "", hotel_spend_share: "", average_package_cost: "" })}
                  variant="ghost"
                  icon={<PlusIcon color="#4C70EF" />}
                  type="button"
                >
                  Add Hotel Supplier
                </Button>
              )}
            </div>
          )}
        </FieldArray>

        <div className={styles.formGroup}>
          <NumberInput
            label="Total % of all spend on Accommodation"
            placeholder="0"
            type="number"
            id="travel_total_spend_accommodation"
            name="travel_total_spend_accommodation"
            value={values.travel_total_spend_accommodation}
            onChange={(value) => setFieldValue("travel_total_spend_accommodation", value)}
            onBlur={handleBlur}
            touched={touched.travel_total_spend_accommodation}
            errored={errors.travel_total_spend_accommodation}
            error={errors.travel_total_spend_accommodation}
          />
        </div>

        {/* Section 5: Local Services */}
        <SectionDivider label="Local Services" />
        <p className={styles.subtitle}>
          Please list local services (transfers, tours etc.) supported (&gt;10% of sales)
        </p>

        <FieldArray name="travel_local_services">
          {({ push, remove }) => (
            <div className={styles.supplierList}>
              {values.travel_local_services?.map((service, index) => (
                <div className={styles.supplierRow} key={index}>
                  <div className={styles.supplierRowInputs}>
                    <TextInput
                      label="Service Provider Name"
                      placeholder="Service Provider"
                      type="text"
                      id={`travel_local_services.${index}.name`}
                      name={`travel_local_services.${index}.name`}
                      value={service.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors?.travel_local_services?.[index]?.name}
                      touched={touched?.travel_local_services?.[index]?.name}
                      errored={errors?.travel_local_services?.[index]?.name}
                    />
                    <TextInput
                      label="Country of base"
                      placeholder="Country"
                      type="text"
                      id={`travel_local_services.${index}.country`}
                      name={`travel_local_services.${index}.country`}
                      value={service.country}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors?.travel_local_services?.[index]?.country}
                      touched={touched?.travel_local_services?.[index]?.country}
                      errored={errors?.travel_local_services?.[index]?.country}
                    />
                    <TextInput
                      label="Payment terms"
                      placeholder="Payment terms"
                      type="text"
                      id={`travel_local_services.${index}.payment_terms`}
                      name={`travel_local_services.${index}.payment_terms`}
                      value={service.payment_terms}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors?.travel_local_services?.[index]?.payment_terms}
                      touched={touched?.travel_local_services?.[index]?.payment_terms}
                      errored={errors?.travel_local_services?.[index]?.payment_terms}
                    />
                    <NumberInput
                      label="% share of 'other' service provider spend"
                      placeholder="0"
                      type="number"
                      id={`travel_local_services.${index}.service_spend_share`}
                      name={`travel_local_services.${index}.service_spend_share`}
                      value={service.service_spend_share}
                      onChange={(value) => setFieldValue(`travel_local_services.${index}.service_spend_share`, value)}
                      onBlur={handleBlur}
                      error={errors?.travel_local_services?.[index]?.service_spend_share}
                      touched={touched?.travel_local_services?.[index]?.service_spend_share}
                      errored={errors?.travel_local_services?.[index]?.service_spend_share}
                    />
                    <NumberInput
                      label="Avg % of package cost"
                      placeholder="0"
                      type="number"
                      id={`travel_local_services.${index}.average_package_cost`}
                      name={`travel_local_services.${index}.average_package_cost`}
                      value={service.average_package_cost}
                      onChange={(value) => setFieldValue(`travel_local_services.${index}.average_package_cost`, value)}
                      onBlur={handleBlur}
                      error={errors?.travel_local_services?.[index]?.average_package_cost}
                      touched={touched?.travel_local_services?.[index]?.average_package_cost}
                      errored={errors?.travel_local_services?.[index]?.average_package_cost}
                    />
                  </div>
                  {index > 0 ? (
                    <div className={styles.supplierRowButtons}>
                      <RemoveButton onClick={() => remove(index)} />
                    </div>
                  ) : (
                    <div className={styles.supplierRowButtons}>
                      <RemoveButton color="#FFF" />
                    </div>
                  )}
                </div>
              ))}
              {values.travel_local_services?.length < 6 && (
                <Button
                  onClick={() => push({ name: "", country: "", payment_terms: "", service_spend_share: "", average_package_cost: "" })}
                  variant="ghost"
                  icon={<PlusIcon color="#4C70EF" />}
                  type="button"
                >
                  Add Service Provider
                </Button>
              )}
            </div>
          )}
        </FieldArray>

        <div className={styles.formGroup}>
          <NumberInput
            label='Total % of all spend on "other" elements than Travel/Accommodation'
            placeholder="0"
            type="number"
            id="travel_total_spend_other"
            name="travel_total_spend_other"
            value={values.travel_total_spend_other}
            onChange={(value) => setFieldValue("travel_total_spend_other", value)}
            onBlur={handleBlur}
            touched={touched.travel_total_spend_other}
            errored={errors.travel_total_spend_other}
            error={errors.travel_total_spend_other}
          />
        </div>

        {/* Section 6: Countries of Travel */}
        <SectionDivider label="Countries of Travel" />
        <p className={styles.subtitle}>
          Please list countries you provide travel to (&gt;10% of sales)
        </p>

        <FieldArray name="travel_countries">
          {({ push, remove }) => (
            <div className={styles.supplierList}>
              {values.travel_countries?.map((country, index) => (
                <div className={styles.supplierRow} key={index}>
                  <div className={styles.supplierRowInputs}>
                    <TextInput
                      label="Country Name"
                      placeholder="Country"
                      type="text"
                      id={`travel_countries.${index}.name`}
                      name={`travel_countries.${index}.name`}
                      value={country.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors?.travel_countries?.[index]?.name}
                      touched={touched?.travel_countries?.[index]?.name}
                      errored={errors?.travel_countries?.[index]?.name}
                    />
                    <NumberInput
                      label="% of overall trade"
                      placeholder="0"
                      type="number"
                      id={`travel_countries.${index}.trade_share`}
                      name={`travel_countries.${index}.trade_share`}
                      value={country.trade_share}
                      onChange={(value) => setFieldValue(`travel_countries.${index}.trade_share`, value)}
                      onBlur={handleBlur}
                      error={errors?.travel_countries?.[index]?.trade_share}
                      touched={touched?.travel_countries?.[index]?.trade_share}
                      errored={errors?.travel_countries?.[index]?.trade_share}
                    />
                  </div>
                  {index > 0 ? (
                    <div className={styles.supplierRowButtons}>
                      <RemoveButton onClick={() => remove(index)} />
                    </div>
                  ) : (
                    <div className={styles.supplierRowButtons}>
                      <RemoveButton color="#FFF" />
                    </div>
                  )}
                </div>
              ))}
              {values.travel_countries?.length < 7 && (
                <Button
                  onClick={() => push({ name: "", trade_share: "" })}
                  variant="ghost"
                  icon={<PlusIcon color="#4C70EF" />}
                  type="button"
                >
                  Add Country
                </Button>
              )}
            </div>
          )}
        </FieldArray>

        {/* Section 7: Seasonality */}
        <SectionDivider label="Seasonality" />
        <p className={styles.subtitle}>
          Please state the split of annual sales volume processed in each month of the year
        </p>

        <div className={styles.seasonalityGrid}>
          <div className={styles.seasonalityGridHeader} />
          {SEASONALITY_OPTIONS.map((option) => (
            <div key={option.key} className={styles.seasonalityGridColumnHeader}>
              {option.label}
            </div>
          ))}
          {MONTHS.map((month) => (
            <React.Fragment key={month}>
              <div className={styles.seasonalityGridRowHeader}>{month}</div>
              {SEASONALITY_OPTIONS.map((option) => {
                const fieldName = `travel_seasonality_${option.key}_${month.toLowerCase()}`;
                return (
                  <div key={fieldName} className={styles.seasonalityGridCell}>
                    <NumberInput
                      placeholder="0"
                      type="text"
                      id={fieldName}
                      name={fieldName}
                      value={values[fieldName]}
                      onChange={(value) => setFieldValue(fieldName, value)}
                      onBlur={handleBlur}
                      touched={touched[fieldName]}
                      errored={errors[fieldName]}
                      error={errors[fieldName]}
                    />
                  </div>
                );
              })}
            </React.Fragment>
          ))}
        </div>

        {/* Section 8: Customer Payment Terms */}
        <SectionDivider label="Customer Payment Terms" />

        <div className={styles.formRow}>
          <NumberInput
            label="Average deposit paid (%)"
            placeholder="0"
            type="number"
            id="travel_average_deposit_percentage"
            name="travel_average_deposit_percentage"
            value={values.travel_average_deposit_percentage}
            onChange={(value) => setFieldValue("travel_average_deposit_percentage", value)}
            onBlur={handleBlur}
            touched={touched.travel_average_deposit_percentage}
            errored={errors.travel_average_deposit_percentage}
            error={errors.travel_average_deposit_percentage}
          />
          <NumberInput
            label="Average time between deposit payment and travel (months)"
            placeholder="0"
            type="number"
            id="travel_average_time_deposit_travel"
            name="travel_average_time_deposit_travel"
            value={values.travel_average_time_deposit_travel}
            onChange={(value) => setFieldValue("travel_average_time_deposit_travel", value)}
            onBlur={handleBlur}
            touched={touched.travel_average_time_deposit_travel}
            errored={errors.travel_average_time_deposit_travel}
            error={errors.travel_average_time_deposit_travel}
          />
        </div>

        <div className={styles.formRow}>
          <NumberInput
            label="Average time between balance payment and travel (months)"
            placeholder="0"
            type="number"
            id="travel_average_time_balance_travel"
            name="travel_average_time_balance_travel"
            value={values.travel_average_time_balance_travel}
            onChange={(value) => setFieldValue("travel_average_time_balance_travel", value)}
            onBlur={handleBlur}
            touched={touched.travel_average_time_balance_travel}
            errored={errors.travel_average_time_balance_travel}
            error={errors.travel_average_time_balance_travel}
          />
        </div>

        <p className={styles.subtitle}> PERIOD FROM DATE OF CARD TRANSACTION TO DATE OF TRAVEL/EVENT/STAY </p>

        <div className={styles.deliveryGrid}>
          {DELIVERY_PERIODS.map((period) => {
            const fieldName = `travel_delivery_${period.key}`;
            return (
              <NumberInput
                key={period.key}
                label={`${period.label} (%)`}
                placeholder="0"
                type="number"
                id={fieldName}
                name={fieldName}
                value={values[fieldName]}
                onChange={(value) => setFieldValue(fieldName, value)}
                onBlur={handleBlur}
                touched={touched[fieldName]}
                errored={errors[fieldName]}
                error={errors[fieldName]}
              />
            );
          })}
        </div>

        {/* Section 9: Additional Information */}
        <SectionDivider label="Additional Information" />

        <div className={styles.formGroup}>
          <TextArea
            label="Please provide any information regarding consumer protection you may have in place:"
            placeholder="Please provide any information regarding consumer protection you may have in place"
            id="travel_consumer_protection"
            name="travel_consumer_protection"
            value={values.travel_consumer_protection || ""}
            onChange={(event) => {console.log(event.target.value); setFieldValue("travel_consumer_protection", event.target.value)}}
            onBlur={handleBlur}
            touched={touched.travel_consumer_protection}
            errored={errors.travel_consumer_protection || ""}
            error={errors.travel_consumer_protection || ""}
          />
        </div>    
      </div>
    </div>
  );
}

export default TravelAddendum;
